module.exports = __webpack_public_path__ + "img/team-max-krause.de65c0c8.jpg";